import React from "react";
import { useReveal } from "@/hooks/useReveal";

const VALUES = [
  { k: "i", t: "Grupos pequenos", d: "Até seis pessoas por aula. Espaço para respirar." },
  { k: "ii", t: "Atenção individual", d: "Correções subtis, ajustes precisos, escuta próxima." },
  { k: "iii", t: "Movimento consciente", d: "Cada exercício pensado para o corpo que está presente." },
  { k: "iv", t: "Ambiente boutique", d: "Estúdio em luz natural, materiais cuidados, silêncio." },
  { k: "v", t: "Corpo & mente", d: "Equilíbrio entre força, mobilidade e presença mental." },
];

export default function Experience() {
  const ref = useReveal();

  return (
    <section
      id="experiencia"
      ref={ref}
      className="relative bg-[var(--luft-bg)] py-32 sm:py-44 lg:py-52 overflow-hidden"
      data-testid="experience-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-16 lg:gap-x-14">
          {/* Visual side */}
          <div className="col-span-12 lg:col-span-5 reveal">
            <div className="relative aspect-[3/4] overflow-hidden" style={{ borderRadius: "var(--radius-organic)" }}>
              <img
                src="/media/luft-reformer-arch.jpg"
                alt="Experiência Lu.ft"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="mt-8 flex items-center justify-between">
              <p className="eyebrow">05 — Experiência</p>
              <p className="font-display italic text-[var(--luft-ink-soft)] text-lg">
                somewhere quiet
              </p>
            </div>
          </div>

          {/* Text side */}
          <div className="col-span-12 lg:col-span-7 lg:pl-12 reveal">
            <h2 className="editorial-heading text-[clamp(2.2rem,5.4vw,4.4rem)] text-[var(--luft-ink)] max-w-2xl">
              Uma experiência <em className="editorial-italic">próxima</em>,
              feita de pequenas atenções.
            </h2>

            <p className="mt-8 text-[var(--luft-ink-soft)] font-body font-light text-base leading-relaxed max-w-xl">
              No Lu.ft, cada aula é pensada para si — não para o grupo, não para a moda, não
              para o cronómetro. Aqui, o tempo desacelera para que o corpo possa, finalmente,
              ser ouvido.
            </p>

            <ul className="mt-14 divide-y divide-[var(--luft-line)] border-y border-[var(--luft-line)]">
              {VALUES.map((v) => (
                <li
                  key={v.k}
                  className="grid grid-cols-12 items-baseline py-6 gap-4"
                  data-testid={`experience-value-${v.k}`}
                >
                  <span className="col-span-2 font-display italic text-[var(--luft-blue)] text-xl">
                    {v.k}
                  </span>
                  <span className="col-span-4 font-display text-xl sm:text-2xl text-[var(--luft-ink)]">
                    {v.t}
                  </span>
                  <span className="col-span-12 sm:col-span-6 text-[var(--luft-ink-soft)] font-body font-light text-sm leading-relaxed">
                    {v.d}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
